import Web3ProviderAdapter from "@/cuties/blockchain/matic/Web3ProviderAdapter";
import type { Web3Provider } from "@/cuties/blockchain/matic/Web3Provider";
import { Blockchain } from "@/cuties/model/pet/BlockchainId";
import type { EthereumConfig } from "@/cuties/blockchain/ethereum/EthereumContractAddresses";
import type Web3 from "web3";
import CutiesApiFaucet from "@/app/cuties/blockchain/CutiesApiFaucet";

export class EthereumUniswapService {
    private adapter: Web3ProviderAdapter;

    constructor(private walletProvider: Web3Provider, private readonly configuration: EthereumConfig) {
        this.adapter = new Web3ProviderAdapter(walletProvider, Blockchain.Ethereum);
    }

    public async token0(lp: string): Promise<string> {
        return this.adapter.callContractMethod<string>({
            contract: "uniswapV2Pool",
            address: lp,
            methodName: "token0",
            methodArguments: [],
        });
    }

    /**
     * return [eth, bcug]
     */
    public async getReserves(lp: string): Promise<string[]> {
        const web3 = await this.getWeb3();
        const token0 = await this.token0(lp);

        const amount = await this.adapter.callContractMethod<string[]>({
            contract: "uniswapV2Pool",
            address: lp,
            methodName: "getReserves",
            methodArguments: [],
        });

        if (token0.toLowerCase() == this.configuration.contracts.bcug.toLowerCase()) {
            return [web3.utils.fromWei(amount[1], "ether"), web3.utils.fromWei(amount[0], "ether")];
        } else {
            return [web3.utils.fromWei(amount[0], "ether"), web3.utils.fromWei(amount[1], "ether")];
        }
    }

    public async totalSupply(lp: string): Promise<string> {
        const web3 = await this.getWeb3();

        const amount = await this.adapter.callContractMethod<string>({
            contract: "uniswapV2Pool",
            address: lp,
            methodName: "totalSupply",
            methodArguments: [],
        });

        return web3.utils.fromWei(amount, "ether");
    }

    private async getWeb3(): Promise<Web3> {
        const Web3 = await CutiesApiFaucet.getWeb3();
        return new Web3();
    }
}
